export default __webpack_public_path__ + "static/media/the-movie-egg.bd41dfbd.png";